import React from 'react';
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import SuspenseLoader from '../SkeletonLoader/SuspenseLoader';
import LineLoader from '../SkeletonLoader/LineLoader';
import { KeyValueItemProps, KeyVariant, ValueVariant } from './interfaces';
import cx from 'classnames';
import styles from './KeyValueList.module.scss';

const KeyValueItem = ({
  keyText,
  keySubText,
  valueText,
  valueSubText,
  showLoader,
  itemClasses
}: KeyValueItemProps) => {
  const renderComponent = (
    item: React.ReactNode,
    isValue: boolean,
    itemSubTitle?: string
  ): React.ReactNode => {
    if (typeof item === 'string' || typeof item === 'number') {
      return (
        <Typography
          variant={isValue ? KeyVariant.H4 : ValueVariant.P3}
          className={cx(styles.keyValueItem__text, {
            [styles['keyValueItem__text--value']]: isValue
          })}
        >
          {item}
          {itemSubTitle && (
            <div>
              <Typography variant="p5" className={styles.keyValueItem__subtext}>
                {itemSubTitle}
              </Typography>
            </div>
          )}
        </Typography>
      );
    }
    return item;
  };
  return (
    <div className={cx(styles.keyValueItem, itemClasses)}>
      {renderComponent(keyText, false, keySubText)}
      <SuspenseLoader
        loading={Boolean(showLoader)}
        fallBack={
          <LineLoader numberOfLines={1} childrenType="P3" dimenshionUnit="px" lineWidth={100} />
        }
      >
        {renderComponent(valueText, true, valueSubText)}
      </SuspenseLoader>
    </div>
  );
};

export default KeyValueItem;
